<template>
  <span v-if="timeStr == '00:00:00'">待开播</span>
  <span v-else>{{ date }} {{ time }} 开播</span>
</template>

<script>
import moment from 'moment';
import {transTimestamp} from '../utils/tool'

export default {
  props: {
    endTime: String,
  },
  data() {
    return {
      timeStr: "",
      timer: null,
      date: '',
      time: ''
    };
  },
  mounted() {
    this.date = this.showTime(this.endTime);
    this.timer = setInterval(() => {
    }, 1000);
  },
  methods: {
    showTime(endTime) {
      // 今日日期比较endtime日期 如果相等 今日 如果大于1 明日 
      let t = +new Date()
      let now = this.transTimestamp(new Date()).split(' ')[0]
      let endArr =this.transTimestamp(endTime).split(' ')
      let tomorrow = this.transTimestamp(t + 1000*24*60*60).split(' ')[0]
      this.time = endArr[1]
      let a = this.transTimestamp(endTime)
      // console.log(endTime,a,endArr[0],now,endArr,tomorrow,this.time,'时间');
      if(endArr[0]==now){
        return '今日'
      }else if(endArr[0]==tomorrow){
        return '明日'
      }else{
        let arr = endArr[0].split('-')
        return arr[1] + '-' + arr[2] 
      }

      // let endtime = new Date(endTime);
      // let lefttime = endtime.getTime() - nowtime.getTime(),
      //   h = Math.floor((lefttime / (1000 * 60 * 60)) % 24),
      //   m = Math.floor((lefttime / (1000 * 60)) % 60),
      //   s = Math.floor((lefttime / 1000) % 60);
      // if (h >= 0) {
      //   if (h < 10) {
      //     h = "0" + h;
      //   }
      //   if (m < 10) {
      //     m = "0" + m;
      //   }
      //   if (s < 10) {
      //     s = "0" + s;
      //   }
      //   this.timeStr = h + ":" + m + ":" + s;
      // } else {
      //   clearInterval(this.timer);
      //   // this.$emit("reload");
      //   this.timeStr = "00:00:00";
      // }
    },
    transTimestamp(
      datetime,
      dateSeprator = "-",
      timeSeprator = ":"
    ) {
      if (datetime) {
        let time = new Date(datetime);
        let year = time.getFullYear()+'';                 //返回当前年份        2022    2022年
        let month = time.getMonth()+1+'';                    //返回当前月份        3       4月
        let date = time.getDate()+'';
        let hour = time.getHours()+'';                     //返回时（0-23）      10      10时
        let minutes = time.getMinutes()+'';                //返回分（0-59）      6       六分
        let seconds = time.getSeconds()+'';                //返回秒（0-59）      32      32秒
        let millseconds = time.getMilliseconds()+'';

        if (month.length === 1) {
          month = `0${month}`;
        }
        if (date.length === 1) {
          date = `0${date}`;
        }
        if (hour.length === 1) {
          hour = `0${hour}`;
        }
        if (minutes.length === 1) {
          minutes = `0${minutes}`;
        }
        if (seconds.length === 1) {
          seconds = `0${seconds}`;
        }
        return `${year}${dateSeprator}${month}${dateSeprator}${date} ${hour}:${minutes}`;
      }
    }
  },
};
</script>
